import React, { Dispatch, SetStateAction } from 'react';

interface BaseModalProps {
  updating: boolean;
  showYouWillLoseChangePopup: { isOpen: boolean, id: string | null, text: string, onPressYes: () => void | undefined };
  setShowYouWillLoseChangePopup: Dispatch<SetStateAction<{ isOpen: boolean; id: string | null; text: string; onPressYes: () => void | undefined; }>>
}

const ProposalYouWillLoseChangesPopup: React.FC<BaseModalProps> = (props) => {
  return (
    <>
      <div className="modal fade show in" id="exampleModal" aria-labelledby="exampleModalLabel" aria-hidden="true" style={{
        zIndex: 1052
      }}>
        <div className="modal-dialog modal-dialog-confirm modal-dialog-centered">
          <div className="modal-content rounded-0">
            <div className="modal-body text-center">
              <div className="container py-4">
                <div className="row justify-content-center">
                  <div className="col">
                    <p className="font-sm font-weight-bold mb-4">
                      {props.showYouWillLoseChangePopup.text}
                    </p>
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-auto">
                    <button className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-md-4 px-4 mr-3" onClick={() => {
                      props.setShowYouWillLoseChangePopup({
                        isOpen: false,
                        id: null,
                        text: '',
                        onPressYes: () => {//
                        }
                      });
                    }} disabled={props.updating}>
                      No
                    </button>
                    <button className="btn btn-primary py-2 font-weight-semibold font-normal px-4 flex-fill" disabled={props.updating} onClick={() => {
                      props.showYouWillLoseChangePopup.onPressYes();
                    }}>
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal-backdrop fade show"
        style={{ zIndex: 1051 }}
      ></div>
    </>
  );
}

export default ProposalYouWillLoseChangesPopup;